export const EXTERNAL_LINKS = {
  Balancer: {
    Home: 'https://docs.acryptos.com/acsi.finance',
    BalForGas:
      'https://docs.balancer.finance/core-concepts/bal-balancer-governance-token/bal-for-gas',
    PoolsV1Dashboard: 'https://pools.balancer.exchange/#/dashboard',
    PoolsV1Explore: 'https://pools.balancer.exchange/#/explore'
  },
  Gauntlet: {
    Home: 'https://gauntlet.network'
  },
  Ethereum: {
    Wallets: 'https://ethereum.org/en/wallets'
  },
  Element: {
    Earn: 'https://app.element.fi/mint',
    Pools: {
      LUSD:
        'https://app.element.fi/pools/0x56F30398d13F111401d6e7ffE758254a0946687d',
      USDC:
        'https://app.element.fi/pools/0x7Edde0CB05ED19e03A9a47CD5E53fC57FDe1c80c'
    }
  },
  Copper: {
    Auctions: (poolAddress: string, networkPrefix = '') =>
      `https://${networkPrefix}copperlaunch.com/auctions/${poolAddress}`
  },
  AcsiFinance: {
    Pool: (poolId: string) => `https://app.acsi.finance/#/pool/${poolId}`,
    Trade: (tokenIn: string, tokenOut: string) =>
      `https://app.acsi.finance/#/trade/${tokenIn}/${tokenOut}`
  }
};
